'use client';

import { usePathname } from 'next/navigation';

import { LocalImage } from '@/components/atoms/LocalImage';

import {
    PAYPO_LOGO_CONFIG,
    PAYU_LOGO_CONFIG,
} from '@/static/content/pl/start/common';

export default function LogoLayout() {
    const pathname = usePathname();
    const isPayu = pathname.includes('/payu');

    return <LocalImage {...(isPayu ? PAYU_LOGO_CONFIG : PAYPO_LOGO_CONFIG)} />;
}
